import axios from "axios"

import { store } from "../store"

export const getUri = () => {
   var url = window.location.host.split('.')

   let domain = (url[0].includes('localhost')) ? 'spring_avirtual_api.test' : 'apiavirtual.spring.com.co'

   return `https://${domain}`
}

export const getClientUri = () => {
   var url = window.location.host.split('.')

   let domain = (url[0].includes('localhost')) ? 'localhost:3013' : 'avirtual.spring.com.co'

   return `https://${domain}`
}

export const getDomain = () => {
   var uri = getUri()
   
   return `${uri}/api`
}

/*
 * Instancia con el servicio principal del backend
 */
const springAvirtualApi = () => {
   const state = store.getState();
   const authToken = state.auth.token;

   return axios.create({
      baseURL: getDomain(),
      timeout: 50000,
      headers: {
         Authorization: `Bearer ${authToken}`,
         "Content-Type": "application/json; charset=UTF-8",
      }
   });
};

export default springAvirtualApi;
